import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getFromInitialData } from 'utils/initial-data';
import { INITIAL_DATA_LOAD, INITIAL_DATA_LOAD_SUCCESS } from '../actions';
import { QUESTION_ADDED } from '../actions/questions';
import { getIsFetched } from '../reducers';

function* loadInitialDatas() {
  const isFetched = yield select(getIsFetched);
  if (!isFetched) {
    // Images
    const strategy = yield call(getFromInitialData, 'strategy', null);
    const image = yield call(getFromInitialData, 'image', null);

    // Questions
    const questions = yield call(getFromInitialData, 'questions', []);

    // Diffusion
    const targets = yield call(getFromInitialData, 'targets', []);

    yield put({
      type: INITIAL_DATA_LOAD_SUCCESS,
      questions,
      targets,
      strategy,
      image,
    });
  }
}

const delay = ms => new Promise(res => setTimeout(res, ms));

function* scrollToBottom() {
  yield delay(150);
  yield call(window.scrollTo, 0, document.body.scrollHeight);
}

export default function* root() {
  yield [
    takeLatest(INITIAL_DATA_LOAD, loadInitialDatas),
    takeLatest(QUESTION_ADDED, scrollToBottom),
  ];
}



// WEBPACK FOOTER //
// ./src/modules/survey/sagas/index.js